export { getFontFaceStyles } from './get-font-face-styles';
